module.exports = __webpack_public_path__ + "files/f8336ce5b32df79a5c0ba8af1f196c2c.png";